import React__default from 'react';
import styled, { keyframes } from 'styled-components';
import { setTestId } from '../../lib/testId.js';
import { getColor } from '../styles/stylePropTypes.js';
import { HappyLoaderSVG } from '../svg/HappyLoaderSVG.js';

const SPINNER_SIZE = {
    large: {
        width: 80,
        height: 80,
        radius: 35
    },
    medium: {
        width: 31,
        height: 31,
        radius: 14
    },
    small: {
        width: 20,
        height: 20,
        radius: 8.75
    }
};
const SpinnerKeyFrames = keyframes`
    0% {
        stroke-width: 12.5%;
        transform: rotate(48deg);
        stroke-dashoffset: 325%;
    }

    6% {
        transform: rotate(32deg);
        stroke-dashoffset: 300%;
    }

    9% {
        transform: rotate(32deg);
        stroke-dashoffset: 300%;
    }

    15% {
        transform: rotate(48deg);
        stroke-dashoffset: 325%;
    }

    18% {
        transform: rotate(48deg);
        stroke-width: 12.5%;
        stroke-dashoffset: 325%;
    }

    40% {
        stroke-dashoffset: 145%;
    }

    50% {
        stroke-width: 4.375%;
    }

    85% {
        stroke-width: 12.5%;
    }

    100% {
        stroke-width: 12.5%;
        transform: rotate(768deg);
        stroke-dashoffset: 325%;
    }
`;
const StyledHappyLoaderSVG = styled(HappyLoaderSVG)`
  transform: rotate(360deg);

  & circle {
    stroke: ${(props)=>getColor(props.$color, props.theme)};
    fill: none;
    animation: ${SpinnerKeyFrames} 2s infinite ease-in-out;
    stroke-dashoffset: 325%;
    stroke-dasharray: 390.625%;
    transform-origin: center;
    stroke-linecap: round;
  }
`;
const LoadingSpinnerOverlayWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props)=>props.$bgOverlay === "partial" ? "rgba(255,255,255,0.8)" : "inherit"};
`;
const LoadingSpinner = ({ color ="context" , size ="large" , testId ="X" , ...props })=>{
    return React__default.createElement(StyledHappyLoaderSVG, {
        "data-hpy-web-load-spinner": true,
        ...props,
        ...SPINNER_SIZE[size],
        ...setTestId("LoadingSpinner-" + testId),
        "$color": color
    });
};
LoadingSpinner.dataId = "data-hpy-web-load-spinner";
LoadingSpinner.displayName = "LoadingSpinner";
const LoadingSpinnerOverlay = ({ color ="context" , size ="large" , bgOverlay ="transparent" , testId ="X" , ...props })=>{
    return React__default.createElement(LoadingSpinnerOverlayWrapper, {
        "data-hpy-web-load-spinner-overlay": true,
        "$bgOverlay": bgOverlay,
        ...props
    }, React__default.createElement(LoadingSpinner, {
        color: color,
        size: size,
        testId: testId
    }));
};
LoadingSpinnerOverlay.dataId = "data-hpy-web-load-spinner-overlay";
LoadingSpinnerOverlay.displayName = "LoadingSpinnerOverlay";

export { LoadingSpinner, LoadingSpinnerOverlay };
